import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function ServiceSolutionsValidationSchema() {
  const { t } = useTranslation('common')

  return z.object({
    serviceSolutionsPassword: z.string().min(1, t('validations.required')),
  })
}

export function PasswordChangeSchema() {
  const { t } = useTranslation('common')

  return z
    .object({
      currentPassword: z.string().min(1, t('validations.required')),
      newPassword: z.string().min(1, t('validations.required')),
      confirmNewPassword: z.string().min(1, t('validations.required')),
    })
    .refine((data) => data.newPassword === data.confirmNewPassword, {
      message: t('validations.passwords_do_not_match'),
      path: ['confirmNewPassword'],
    })
}

export function PasswordDefinitionSchema() {
  const { t } = useTranslation('common')

  return z.object({
    newPassword: z.string().min(1, t('validations.required')),
  })
}

export type ServiceSolutionsValidationForm = z.infer<
  ReturnType<typeof ServiceSolutionsValidationSchema>
>

export type PasswordChangeForm = z.infer<
  ReturnType<typeof PasswordChangeSchema>
>

export type PasswordDefinitionForm = z.infer<
  ReturnType<typeof PasswordDefinitionSchema>
>
